export default __webpack_public_path__ + "static/media/pictogramBeaconClock48.ae7f8e92.svg";